import { Link } from "react-router-dom";
import ThemeLogo from "@/components/ThemeLogo";
import { useLanguage } from "@/contexts/LanguageContext";
import { useLocalePath } from "@/hooks/useLocalePath";
import certFssc from "@/assets/cert-fssc-22000.png";
import certEcovadis from "@/assets/cert-ecovadis.png";

const PublicFooter = () => {
  const { t } = useLanguage();
  const lp = useLocalePath();

  return (
    <footer className="dark bg-[hsl(220,30%,12%)] border-t border-[hsl(220,25%,20%)] py-14" aria-label="Footer navigatie">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-5 gap-10 mb-10">
          <div>
            <div className="mb-4">
              <ThemeLogo className="h-8" variant="light" />
            </div>
            <p className="text-sm text-[hsl(220,15%,55%)] mb-5">
              {t("footer.description")}
            </p>
            <div className="flex items-center gap-3">
              <img
                src={certFssc}
                alt="FSSC 22000 gecertificeerd"
                loading="lazy"
                className="h-12 w-auto object-contain"
              />
              <img
                src={certEcovadis}
                alt="EcoVadis Bronze sustainability rating"
                loading="lazy"
                className="h-14 w-auto object-contain"
              />
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-[hsl(220,15%,85%)]">{t("footer.ordering")}</h4>
            <div className="flex flex-col gap-2.5 text-sm text-[hsl(220,15%,55%)]">
              <Link to={lp("/bestellen/eps")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.epsOrder")}</Link>
              <Link to={lp("/offerte")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.containerOrder")}</Link>
              <Link to={lp("/offerte")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.quoteRequest")}</Link>
              <Link to={lp("/kennisbank")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.kennisbank")}</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-[hsl(220,15%,85%)]">{t("footer.solutions")}</h4>
            <div className="flex flex-col gap-2.5 text-sm text-[hsl(220,15%,55%)]">
              <Link to={lp("/oplossingen/horeca-catering")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("landing.branchHoreca")}</Link>
              <Link to={lp("/oplossingen/medisch-farmaceutisch")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("landing.branchPharma")}</Link>
              <Link to={lp("/oplossingen/transport-logistiek")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("landing.branchTransport")}</Link>
              <Link to={lp("/oplossingen/voedselindustrie")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("landing.branchFood")}</Link>
              <Link to={lp("/oplossingen/industrieel-reinigen")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("landing.branchCleaning")}</Link>
              <Link to={lp("/oplossingen/evenementen")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("landing.branchEvents")}</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-[hsl(220,15%,85%)]">{t("footer.cities") || "Steden"}</h4>
            <div className="grid grid-cols-2 gap-x-3 gap-y-2 text-sm text-[hsl(220,15%,55%)]">
              <Link to={lp("/droogijs-kopen-amsterdam")} className="hover:text-[hsl(220,15%,85%)] transition-colors">Amsterdam</Link>
              <Link to={lp("/droogijs-kopen-rotterdam")} className="hover:text-[hsl(220,15%,85%)] transition-colors">Rotterdam</Link>
              <Link to={lp("/droogijs-kopen-den-haag")} className="hover:text-[hsl(220,15%,85%)] transition-colors">Den Haag</Link>
              <Link to={lp("/droogijs-kopen-utrecht")} className="hover:text-[hsl(220,15%,85%)] transition-colors">Utrecht</Link>
              <Link to={lp("/droogijs-kopen-eindhoven")} className="hover:text-[hsl(220,15%,85%)] transition-colors">Eindhoven</Link>
              <Link to={lp("/droogijs-kopen-groningen")} className="hover:text-[hsl(220,15%,85%)] transition-colors">Groningen</Link>
              <Link to={lp("/droogijs-kopen-tilburg")} className="hover:text-[hsl(220,15%,85%)] transition-colors">Tilburg</Link>
              <Link to={lp("/droogijs-kopen-almere")} className="hover:text-[hsl(220,15%,85%)] transition-colors">Almere</Link>
              <Link to={lp("/droogijs-kopen-breda")} className="hover:text-[hsl(220,15%,85%)] transition-colors">Breda</Link>
              <Link to={lp("/droogijs-kopen-arnhem")} className="hover:text-[hsl(220,15%,85%)] transition-colors">Arnhem</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-[hsl(220,15%,85%)]">{t("footer.contact")}</h4>
            <div className="flex flex-col gap-2.5 text-sm text-[hsl(220,15%,55%)]">
              <a href="mailto:info@dutchdryice.com" className="hover:text-[hsl(220,15%,85%)] transition-colors">info@dutchdryice.com</a>
              <a href="tel:+31851094630" className="hover:text-[hsl(220,15%,85%)] transition-colors">+31 85 109 4630</a>
              <span>{t("footer.available247")}</span>
              <Link to={lp("/track")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.trackTrace")}</Link>
              <Link to={lp("/faq")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.faq")}</Link>
              <Link to={lp("/over-ons")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.aboutUs")}</Link>
            </div>
          </div>
        </div>
        <div className="border-t border-[hsl(220,15%,25%)] pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[hsl(220,15%,40%)]">
            © {new Date().getFullYear()} Dutch DryIce. {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-6 text-sm text-[hsl(220,15%,55%)]">
            <Link to={lp("/algemene-voorwaarden")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.terms")}</Link>
            <Link to={lp("/privacy")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.privacy")}</Link>
            <Link to={lp("/login")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.login")}</Link>
            <Link to={lp("/signup")} className="hover:text-[hsl(220,15%,85%)] transition-colors">{t("footer.register")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
